import React, { useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';

const Gallery = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('/images-list.php')
            .then((res) => res.json())
            .then((data) => {
                if (!data.success) {
                    throw new Error(data.message || 'Galerii se nepodařilo načíst.');
                }
                setImages(data.images || []);
            })
            .catch(() => {
                setError('Galerii se nepodařilo načíst.');
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="container my-5">
            <h1 className="text-center text-uppercase mb-4">Galerie</h1>

            {loading && (
                <div className="text-center my-5">
                    <Spinner animation="border" role="status" />
                </div>
            )}

            {!loading && error && (
                <p className="text-center text-danger">{error}</p>
            )}

            {!loading && !error && images.length === 0 && (
                <p className="text-center">Zatím tu nejsou žádné fotky.</p>
            )}

            {!loading && !error && images.length > 0 && (
                <div className="row g-3">
                    {images.map((image) => (
                        <div className="col-6 col-md-4 col-lg-3" key={image.name}>
                            <div
                                className="gallery-image position-relative overflow-hidden"
                                onClick={() => setSelectedImage(image.url)}
                                style={{
                                    cursor: 'pointer',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                }}
                            >
                                <img
                                    src={image.url}
                                    alt="Galerie"
                                    className="img-fluid"
                                    loading="lazy"
                                    style={{
                                        transition: 'transform 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => (e.target.style.transform = 'scale(1.1)')}
                                    onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Modal pro zvětšení obrázku */}
            <Modal show={!!selectedImage} onHide={() => setSelectedImage(null)} size="lg" centered>
                <Modal.Body className="bg-dark text-center">
                    {selectedImage && (
                        <img
                            src={selectedImage}
                            alt="Zvětšeno"
                            className="img-fluid rounded"
                        />
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Gallery;
